import { render, staticRenderFns } from "./Bussiness.vue?vue&type=template&id=3c242fd5&scoped=true"
import script from "./Bussiness.vue?vue&type=script&lang=js"
export * from "./Bussiness.vue?vue&type=script&lang=js"
import style1 from "./Bussiness.vue?vue&type=style&index=1&id=3c242fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c242fd5",
  null
  
)

export default component.exports